var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('h1',[_vm._v(_vm._s(_vm.title))]),_c('h2',[_vm._v("Find out which games you and your friends have in common.")])])}
var staticRenderFns = []

export { render, staticRenderFns }